import { TextFieldProps } from '@mui/material/TextField/TextField';
import _uniqueId from 'lodash/uniqueId';

import {
  LegacyFieldWrapper,
  LegacyFieldWrapperPropsFragment,
  LegacyMuiTextField,
} from '~/legacy-components/LegacyForms';

type Props = LegacyFieldWrapperPropsFragment & TextFieldProps;

export const LegacyInputField = (props: Props) => {
  const { label, fieldError, required, help, highlightLabel, ...rest } = props;
  const fieldId = _uniqueId('legacyInputField-');

  return (
    <LegacyFieldWrapper
      fieldId={fieldId}
      label={label}
      required={required}
      fieldError={fieldError}
      highlightLabel={highlightLabel}
      help={help}
    >
      <LegacyMuiTextField
        {...rest}
        error={!!fieldError || props.error}
        id={fieldId}
      />
    </LegacyFieldWrapper>
  );
};
